import { useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

type Props = {
  tabs: string[];
  currTab: string;
  onChange: (value: string) => void;
};

export default function SettingsTabs({ tabs, currTab, onChange }: Props) {
  const { t } = useTranslation("chat");
  const [activeTabBlockStyle, setActiveTabBlockStyle] = useState({ width: 0, left: 0 });
  const refs = useRef([]);

  useLayoutEffect(() => {
    const index = tabs.findIndex((tab) => tab === currTab);
    if (refs.current[index]) {
      const activeTabElement = refs.current[index];
      const { offsetWidth, offsetLeft } = activeTabElement;

      setActiveTabBlockStyle({ width: offsetWidth, left: offsetLeft });
    }
  }, [currTab, tabs]);

  return (
    <div
      className={clsx(
        "relative h-[2.625rem] w-full p-1 grid grid-cols-2 gap-1 shrink-0 in",
        "rounded-[0.375rem] overflow-clip  bg-dark-800",
      )}
    >
      <div
        className={clsx(
          "absolute h-full w-[50%] bg-gradient-accent-solid rounded-[0.375rem] transition-all z-0",
        )}
      />
      {tabs.map((item, index) => (
        <button
          key={item}
          type="button"
          className={clsx(
            "h-full text-12 font-bold hover:text-white transition-all z-1",
            item === currTab ? "text-white" : "text-white/50",
          )}
          onClick={() => onChange(item)}
          ref={(el) => {
            refs.current[index] = el;
            return el;
          }}
        >
          {t(item)}
        </button>
      ))}
      <div
        className="absolute h-full bg-gradient-red rounded-[0.5rem] duration-300 z-0"
        style={{
          width: `${activeTabBlockStyle.width}px`,
          transform: `translateX(${activeTabBlockStyle.left}px)`,
        }}
      />
    </div>
  );
}
